const TYPE2NAMES = {
    smartcabinet: 'Intelligent Cabinet',
    cabinet: 'Intelligent Cabinet',
    encodingstation: 'Encoding Station',
    gatereader: 'Gate Reader',
    handheldreader: 'Handheld Reader',
    edgeserver: 'Edge Server',
    forklift: 'Forklift',
    'logistics/pc': 'Middleware PC',
    smartshelf: 'Intelligent Shelf',
    hammer: 'Hammer',
    intelligentinventory: 'Intelligent Inventory',
    ivmicabinet: 'IVMI Cabiner',
    readingpoint: 'Reading Point',

};

export default function deviceTypeIdToText(type) {
    if (!type) {
        return '';
    }

    const lowerType = type.toLowerCase();

    if (TYPE2NAMES[lowerType] === undefined) {
        return type;
    }

    return TYPE2NAMES[lowerType];
}
